/**
 * 接口获取配置类型
 */
export enum apiConfigType {
  urls = 'urls',
  commons = 'commons',
}
